import React from 'react';
import PropTypes from 'prop-types';

import Money from '../../../common/money';

const MembershipsStats = ({ stats }) => (
  <div className="c-membership-stats-container u-mt+">
    <div className="c-memberships-container">
      <div className="c-memberships-container__text_small">Total Members</div>
      <div className="c-memberships-container__title">
        { stats && stats.total }
      </div>
    </div>
    <div className="c-memberships-container">
      <div className="c-memberships-container__text_small">Active Members</div>
      <div className="c-memberships-container__title">
        { stats && stats.active }
      </div>
    </div>
    <div className="c-memberships-container">
      <div className="c-memberships-container__text_small">Paused Members</div>
      <div className="c-memberships-container__title">
        { stats && stats.paused }
      </div>
    </div>
    <div className="c-memberships-container">
      <div className="c-memberships-container__text_small">Recurring Revenue</div>
      <div className="c-memberships-container__title">
        <Money display-if={stats}>
          {stats.projectedMonthlyRevenue}
        </Money>
      </div>
    </div>
  </div>
);

MembershipsStats.propTypes = {
  stats: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.oneOf([null]).isRequired,
  ]).isRequired,
};

export default MembershipsStats;
